import { CameraSettings, CameraSettingsApi } from '@/types/CameraSettings';
import { Vector3 } from 'three';

export class CameraSettingsMapper {
    private static properties: Array<keyof CameraSettingsApi> = ['distance', 'polarAngle', 'position', 'target'];

    static getCameraSettingsFromData(cameraSettingsData: CameraSettingsApi): CameraSettings {
        CameraSettingsMapper.checkCameraSettingsData(cameraSettingsData);
        const { distance, polarAngle, position, target } = cameraSettingsData;

        const cameraSettings: CameraSettings = {
            minDistance: distance[0] ?? 10,
            maxDistance: distance[1] ?? 30,
            minPolarAngle: polarAngle[0] ?? 0,
            maxPolarAngle: polarAngle[1] ?? Math.PI,
            position: new Vector3(position.x ?? -20, position.y ?? 10, position.z ?? 0),
            target: new Vector3(target.x ?? 0, target.y ?? 4, target.z ?? 0)
        };

        return cameraSettings;
    }

    private static checkCameraSettingsData(cameraSettingsData: CameraSettingsApi): void {
        this.properties.forEach((property) => {
            if (cameraSettingsData[property] == null) {
                console.error(`Property ${property} is missing or undefined in camera settings`);
            }
        });
    }
}
